import styled from "@emotion/styled";

export const LayoutContainer = styled.div`
  width: 100%;
  padding: 30px;
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  max-height: 92%;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 6px;
    width: 7px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.main[9]};
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`;
